import Axios from "axios";

// Voice agent lives on the admin/CX backend. Override with NEXT_PUBLIC_VOICE_AGENT_BACKEND
// when storefront NEXT_PUBLIC_BACKEND does not expose /voice_agent/* routes.
const voiceAgentBase =
  process.env.NEXT_PUBLIC_VOICE_AGENT_BACKEND ||
  process.env.NEXT_PUBLIC_BACKEND ||
  "";

const realtimeSessionURL = "/voice_agent/realtime/session";
const v2SessionURL = "/voice_agent/v2/session";
const v2AskURL = "/voice_agent/v2/ask";
const orderStatusURL = "/voice_agent/orders/";
const productSearchURL = "/voice_agent/products/search";
const ticketsURL = "/voice_agent/tickets";
const handoffsURL = "/voice_agent/handoffs";
const chatsURL = "/voice_agent/chats";
const knowledgeSearchURL = "/voice_agent/knowledge/search";

const VoiceAgentApi = {
  createRealtimeSession(params) {
    return Axios({
      url: voiceAgentBase + realtimeSessionURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
  createV2Session(params) {
    return Axios({
      url: voiceAgentBase + v2SessionURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
  askV2(params) {
    return Axios({
      url: voiceAgentBase + v2AskURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
  getOrderStatus(orderNumber, params) {
    const mobile = params?.mobile ? String(params.mobile).trim() : "";
    const query = mobile ? `?mobile=${encodeURIComponent(mobile)}` : "";
    return Axios({
      url: voiceAgentBase + orderStatusURL + encodeURIComponent(orderNumber) + query,
      method: "get",
    }).then((response) => response);
  },
  getCustomerOrderStatus(orderNumber) {
    const storefrontBase = process.env.NEXT_PUBLIC_BACKEND || "";
    return Axios({
      url: `${storefrontBase}/storefront/customer_order_status`,
      method: "post",
      data: { name: String(orderNumber).trim() },
    }).then((response) => response);
  },
  searchProducts(query, limit = 5) {
    return Axios({
      url: `${voiceAgentBase}${productSearchURL}?query=${encodeURIComponent(query)}&limit=${limit}`,
      method: "get",
    }).then((response) => response);
  },
  createTicket(params) {
    return Axios({
      url: voiceAgentBase + ticketsURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
  createHandoff(params) {
    return Axios({
      url: voiceAgentBase + handoffsURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
  saveChat(params) {
    return Axios({
      url: voiceAgentBase + chatsURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
  searchKnowledge(params) {
    return Axios({
      url: voiceAgentBase + knowledgeSearchURL,
      method: "post",
      data: params,
    }).then((response) => response);
  },
};

export default VoiceAgentApi;
